/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "dataapi",
            "endpoint": "https://cmd9yjahic.execute-api.eu-central-1.amazonaws.com/dlpeu",
            "region": "eu-central-1"
        },
        {
            "name": "identifyapi",
            "endpoint": "https://y5bs3j3lqg.execute-api.eu-central-1.amazonaws.com/dlpeu",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:f999391c-94dc-4967-9972-3efc5ba9555a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_BEXwcDRXr",
    "aws_user_pools_web_client_id": "72cqlqipslrth1u0s7tp814rsi",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
